import marketDataStore from './MarketDataStore';

class MarketDataParser {
  parseDetailedData(data) {
    try {
      // Handle binary data using DataView
      const buffer = new Uint8Array(data).buffer;
      const view = new DataView(buffer);
      let offset = 0;

      // Parse each field according to its byte size
      const mode = view.getInt8(offset); offset += 1;              // 1 byte
      const exchange = view.getInt8(offset); offset += 1;          // 1 byte
      const token = view.getInt32(offset); offset += 4;            // 4 bytes
      const ltp = view.getInt32(offset); offset += 4;              // 4 bytes
      const ltt = view.getInt32(offset); offset += 4;              // 4 bytes
      const ltq = view.getInt32(offset); offset += 4;              // 4 bytes
      const volume = view.getInt32(offset); offset += 4;           // 4 bytes
      const bestBidPrice = view.getInt32(offset); offset += 4;     // 4 bytes
      const bestBidQty = view.getInt32(offset); offset += 4;       // 4 bytes
      const bestAskPrice = view.getInt32(offset); offset += 4;     // 4 bytes
      const bestAskQty = view.getInt32(offset); offset += 4;       // 4 bytes
      const totalBuyQty = view.getBigInt64(offset); offset += 8;   // 8 bytes
      const totalSellQty = view.getBigInt64(offset); offset += 8;  // 8 bytes
      const atp = view.getInt32(offset); offset += 4;              // 4 bytes
      const exchangeTs = view.getInt32(offset); offset += 4;       // 4 bytes
      const open = view.getInt32(offset); offset += 4;             // 4 bytes
      const high = view.getInt32(offset); offset += 4;             // 4 bytes
      const low = view.getInt32(offset); offset += 4;              // 4 bytes
      const close = view.getInt32(offset); offset += 4;            // 4 bytes
      const yearlyHigh = view.getInt32(offset); offset += 4;       // 4 bytes
      const yearlyLow = view.getInt32(offset); offset += 4;        // 4 bytes
      const lowDPR = view.getInt32(offset); offset += 4;           // 4 bytes
      const highDPR = view.getInt32(offset); offset += 4;          // 4 bytes
      const currentOI = view.getInt32(offset); offset += 4;        // 4 bytes
      const initialOI = view.getInt32(offset);                     // 4 bytes

      // Calculate change and change percentage
      const change = ltp - close;
      const changePercent = close ? (change / close) * 100 : 0;

      const parsedData = {
        mode,
        exchange,
        token,
        ltp,
        ltq,
        ltt,
        volume,
        bestBid: {
          price: bestBidPrice,
          quantity: bestBidQty
        },
        bestAsk: {
          price: bestAskPrice,
          quantity: bestAskQty
        },
        totalBuyQty: Number(totalBuyQty),
        totalSellQty: Number(totalSellQty),
        atp,
        exchangeTimestamp: exchangeTs,
        open,
        high,
        low,
        close,
        yearlyHigh,
        yearlyLow,
        dpr: {
          low: lowDPR,
          high: highDPR
        },
        oi: {
          current: currentOI,
          initial: initialOI
        },
        change,
        changePercent,
        timestamp: new Date().getTime()
      };

      // Update the market data store with exchange and token
      marketDataStore.updateMarketData(exchange, token, parsedData);
      
      return parsedData;
    } catch (error) {
      console.error('Error parsing binary market data:', error);
      return null;
    }
  }
}

export const marketDataParser = new MarketDataParser(); 